import React from "react"

class RetroUpdaterComponent extends React.Component {

	render() {
		return (
			<div className="retro-updater">
				<span>Êtes-vous sûr de vouloir appliquer les valeurs du scénario <strong>{this.props.scenario.description}</strong> ?</span>
				<br />
				<br />
				<button className={`button is-primary ${this.props.submitting ? "is-loading" : ""}`} onClick={this.props.onRetroUpdated}>Appliquer les valeurs</button>
			</div>
		)
	}

}

export default RetroUpdaterComponent



// WEBPACK FOOTER //
// ./src/component/scenarii/manager/retro-updater-component.js